import { render, staticRenderFns } from "./BtnCancelarPedido.vue?vue&type=template&id=ded5e726&"
import script from "./BtnCancelarPedido.vue?vue&type=script&lang=js&"
export * from "./BtnCancelarPedido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports